if (!customElements.get('subcollection-inline')) {
  customElements.define(
    'subcollection-inline',
    class SubcollectionInline extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        var dataScript = this.querySelector('[data-subcollection-products]');
        if (!dataScript) return;

        try {
          this.productsData = JSON.parse(dataScript.textContent);
        } catch (e) {
          console.warn('subcollection-inline: JSON parse error', e);
          return;
        }

        this.titleEl = this.querySelector('.subcollection-inline__title');
        this.backBtn = this.querySelector('.subcollection-inline__back');
        this.backWrap = this.querySelector('.subcollection-inline__back-wrap');
        this.carouselWrap = this.querySelector('.subcollection-inline__carousel-wrap');
        this.productViews = this.querySelectorAll('.subcollection-inline__product');
        this.mainImage = this.querySelector('.subcollection-inline__main-image');
        this.imageLink = this.querySelector('.subcollection-inline__image-link');
        this.originalTitle = this.titleEl ? this.titleEl.dataset.originalTitle : '';
        this.originalTitleHref = this.titleEl ? this.titleEl.getAttribute('href') : '';
        this.priceEl = this.querySelector('.subcollection-inline__price');

        // Save hover image for restoring later
        var mediaContainer = this.querySelector('.card__media .media');
        if (mediaContainer) {
          var imgs = mediaContainer.querySelectorAll('img');
          this.hoverImageHTML = imgs.length > 1 ? imgs[1].cloneNode(true) : null;
        }
        this.activeIndex = null;

        // Carousel scroll elements
        this.carousel = this.querySelector('.subcollection-inline__carousel');
        this.arrowPrev = this.querySelector('.subcollection-inline__arrow--prev');
        this.arrowNext = this.querySelector('.subcollection-inline__arrow--next');

        var self = this;
        this.querySelectorAll('.subcollection-inline__thumb').forEach(function (thumb) {
          thumb.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var index = parseInt(this.dataset.productIndex);
            self.showProduct(index);
          });
        });

        if (this.backBtn) {
          this.backBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.showCarousel();
          });
        }

        // Carousel arrow navigation
        if (this.carousel && this.arrowPrev && this.arrowNext) {
          this.arrowPrev.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.scrollCarousel(-1);
          });

          this.arrowNext.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.scrollCarousel(1);
          });

          this.carousel.addEventListener('scroll', function () {
            self.updateArrows();
          });

          // Initial arrow state after layout
          requestAnimationFrame(function () {
            self.updateArrows();
          });
        }
      }

      scrollCarousel(direction) {
        if (!this.carousel) return;
        var thumbWidth = this.carousel.querySelector('.subcollection-inline__thumb');
        var scrollAmount = thumbWidth ? thumbWidth.offsetWidth + 4 : 80;
        this.carousel.scrollBy({ left: direction * scrollAmount * 2, behavior: 'smooth' });
      }

      updateArrows() {
        if (!this.carousel || !this.arrowPrev || !this.arrowNext) return;
        var scrollLeft = this.carousel.scrollLeft;
        var maxScroll = this.carousel.scrollWidth - this.carousel.clientWidth;

        if (maxScroll <= 2) {
          // No overflow — hide both arrows
          this.arrowPrev.classList.add('hidden');
          this.arrowNext.classList.add('hidden');
          return;
        }

        if (scrollLeft <= 2) {
          this.arrowPrev.classList.add('hidden');
        } else {
          this.arrowPrev.classList.remove('hidden');
        }

        if (scrollLeft >= maxScroll - 2) {
          this.arrowNext.classList.add('hidden');
        } else {
          this.arrowNext.classList.remove('hidden');
        }
      }

      showProduct(index) {
        this.activeIndex = index;
        var product = this.productsData[index];
        if (!product) return;

        // Update title and link
        if (this.titleEl) {
          this.titleEl.textContent = product.title;
          if (product.url) this.titleEl.setAttribute('href', product.url);
        }

        // Update price to show product variant price
        if (this.priceEl && product.price_formatted) {
          var isSale = product.compare_at_price && product.compare_at_price > product.price;
          var regularPrice = this.priceEl.querySelector('.price__regular .price-item--regular');
          var saleComparePrice = this.priceEl.querySelector('.price__sale .price-item--regular');
          var salePrice = this.priceEl.querySelector('.price__sale .price-item--sale');

          if (regularPrice) regularPrice.textContent = product.price_formatted;
          if (saleComparePrice && product.compare_at_price_formatted) saleComparePrice.textContent = product.compare_at_price_formatted;
          if (salePrice) salePrice.textContent = product.price_formatted;

          this.priceEl.classList.toggle('price--on-sale', isSale);
        }

        // Show back button
        if (this.backWrap) this.backWrap.classList.remove('hidden');

        // Hide carousel
        if (this.carouselWrap) this.carouselWrap.classList.add('hidden');

        // Hide all product views, show selected
        this.productViews.forEach(function (view) { view.classList.add('hidden'); });
        var activeView = this.querySelector('.subcollection-inline__product[data-product-index="' + index + '"]');
        if (activeView) activeView.classList.remove('hidden');

        // Remove any active image carousel controls from card__media
        var cardMedia = this.querySelector('.card__media');
        if (cardMedia) {
          cardMedia.querySelectorAll('.subcollection-inline__img-arrow').forEach(function (el) { el.remove(); });
          cardMedia.querySelectorAll('.subcollection-inline__img-dots').forEach(function (el) { el.remove(); });
        }

        // Keep hover effect, update or create hover image with product's second image
        var mediaLink = this.querySelector('.card__media .media');
        if (mediaLink) {
          var imgs = mediaLink.querySelectorAll('img');
          var hoverImg = imgs.length > 1 ? imgs[1] : null;

          if (product.hover_image) {
            mediaLink.classList.add('media--hover-effect');
            if (hoverImg) {
              // Update existing hover image
              this.updateImgSrc(hoverImg, product.hover_image);
            } else {
              // Create new hover image
              var newHoverImg = document.createElement('img');
              newHoverImg.classList.add('motion-reduce');
              newHoverImg.setAttribute('loading', 'lazy');
              if (this.mainImage) newHoverImg.setAttribute('sizes', this.mainImage.getAttribute('sizes') || '');
              this.updateImgSrc(newHoverImg, product.hover_image);
              mediaLink.appendChild(newHoverImg);
            }
          } else {
            // No hover image available — remove hover effect and extra images
            mediaLink.classList.remove('media--hover-effect');
            for (var i = imgs.length - 1; i > 0; i--) {
              imgs[i].remove();
            }
          }
        }

        // Update main image
        if (this.mainImage && product.image) {
          this.mainImage.setAttribute('src', product.image);
          this.mainImage.setAttribute('loading', 'eager');
          if (product.image_srcset) {
            this.mainImage.setAttribute('srcset', product.image_srcset);
          }
          if (product.image_alt) {
            this.mainImage.setAttribute('alt', product.image_alt);
          }
        }

        // Update image link to point to product
        if (this.imageLink && product.url) {
          this.imageLink.setAttribute('href', product.url);
        }
      }

      showCarousel() {
        this.activeIndex = null;

        // Restore title and link
        if (this.titleEl) {
          this.titleEl.textContent = this.originalTitle;
          if (this.originalTitleHref) this.titleEl.setAttribute('href', this.originalTitleHref);
        }

        // Restore min price ("ab X")
        if (this.priceEl) {
          var minFormatted = this.priceEl.dataset.minPriceFormatted;
          var regularPrice = this.priceEl.querySelector('.price__regular .price-item--regular');
          if (regularPrice && minFormatted) regularPrice.innerHTML = minFormatted;
          this.priceEl.classList.remove('price--on-sale');
        }

        // Hide back button
        if (this.backWrap) this.backWrap.classList.add('hidden');

        // Show carousel
        if (this.carouselWrap) this.carouselWrap.classList.remove('hidden');

        // Hide all product views
        this.productViews.forEach(function (view) { view.classList.add('hidden'); });

        // Remove image carousel controls from card__media
        var cardMedia = this.querySelector('.card__media');
        if (cardMedia) {
          cardMedia.querySelectorAll('.subcollection-inline__img-arrow').forEach(function (el) { el.remove(); });
          cardMedia.querySelectorAll('.subcollection-inline__img-dots').forEach(function (el) { el.remove(); });
        }

        // Restore hover effect + hover image on media link
        var mediaLink = this.querySelector('.card__media .media');
        if (mediaLink) {
          mediaLink.classList.add('media--hover-effect');

          // Restore hover image if it was saved
          if (this.hoverImageHTML) {
            var existingImgs = mediaLink.querySelectorAll('img');
            // Remove any extra images beyond the main one
            for (var i = existingImgs.length - 1; i > 0; i--) {
              existingImgs[i].remove();
            }
            mediaLink.appendChild(this.hoverImageHTML.cloneNode(true));
          }
        }

        // Restore main image
        if (this.mainImage) {
          var originalSrc = this.mainImage.dataset.originalSrc;
          var originalSrcset = this.mainImage.dataset.originalSrcset;
          if (originalSrc) this.mainImage.setAttribute('src', originalSrc);
          if (originalSrcset) this.mainImage.setAttribute('srcset', originalSrcset);
        }

        // Restore image link to collection
        if (this.imageLink) {
          this.imageLink.setAttribute('href', this.imageLink.dataset.defaultUrl);
        }

        // Re-check arrows after showing carousel
        var self = this;
        requestAnimationFrame(function () {
          self.updateArrows();
        });
      }

      updateImgSrc(img, url) {
        var widths = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];
        var srcset = widths
          .map(function (w) { return url.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; })
          .join(', ');
        img.setAttribute('srcset', srcset);
        img.setAttribute('src', url);
        img.setAttribute('loading', 'eager');
      }
    }
  );
}
